import { render, staticRenderFns } from "./addUpdateLead.vue?vue&type=template&id=087650a5&scoped=true&"
import script from "./addUpdateLead.vue?vue&type=script&lang=js&"
export * from "./addUpdateLead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087650a5",
  null
  
)

export default component.exports